// extracted by mini-css-extract-plugin
module.exports = {"item":"ArrowPointer_item__3ka0Q","arrow":"ArrowPointer_arrow__2sKza","top":"ArrowPointer_top__1ysgn","bottom":"ArrowPointer_bottom__2dGRQ","content":"ArrowPointer_content__eA9Tu"};